import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Input, DatePicker, Select } from "antd";
import Api from "../../../../../services/ServiceApi";
import moment from "moment";
import Cookies from "js-cookie";
import ModalSuccess from "../../../../../components/Modal_Success";
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;

const LockingDocumentModal = ({ handleVisible, lockedData }) => {
  //https://planb.maxitask.com/maxioperationapi/
  const [categoryData, setCategoryData] = useState([]);
  const [periodData, setPeriodData] = useState([]);
  const [selCategory, setSelCategory] = useState(0);
  const [selPeriod, setSelPeriod] = useState("");
  const [selPlanStart, setSelPlanStart] = useState("");
  const [selPlanEnd, setSelPlanEnd] = useState("");
  const [selInform, setSelInform] = useState("");
  const [selRemark, setSelRemark] = useState("");
  const [i_single_job_flag, seti_single_job_flag] = useState(0);
  const [modalstatus, setmodalstatus] = useState(false);
  useEffect(() => {
    Api.post("get_query_group_list", {
      "company_id": "1"
      , "operator_id": "3"
      , "project_id": "1"
      , "query_id": "24,25"
      , "query_module" : "bus"
      , "param_text": ""
      , "where_cond": ""
    }).then((res) => {
      setCategoryData(res.data.data.filter_bus_job_interface_mapping)
      setPeriodData(res.data.data.filter_ma_period)
    });
  }, []);

  useEffect(() => {
    setSelCategory(selCategory)
  }, { selCategory });

  useEffect(() => {
    setSelPeriod(selPeriod)
  }, { selPeriod });

  useEffect(() => {
    setSelPlanStart(selPlanStart)
  }, { selPlanStart });

  useEffect(() => {
    setSelPlanEnd(selPlanEnd)
  }, { selPlanEnd });

  useEffect(() => {
    setSelInform(selInform)
  }, { selInform });

  useEffect(() => {
    setSelRemark(selRemark)
  }, { selRemark });

  function checkStatusInternal(fw, qw, led, special) {
    if (fw) {
      return "fw";
    } else if (qw) {
      return "qw";
    } else if (led) {
      return "led";
    } else if (special) {
      return "special";
    } else return "-";
  }

  function checkStatusExternal(ib, hg, lcd) {
    if (ib) {
      return "ib";
    } else if (hg) {
      return "hg";
    } else if (lcd) {
      return "lcd";
    } else return "-";
  }

  const handleChangeInform = (e) => {
    // console.log('handleChangeInform',e.target.value);
    setSelInform(e.target.value)
  }

  const handleChangeRemark = (e) => {
    // console.log('handleChangeRemark',e.target.value);
    setSelRemark(e.target.value)
  }

  function clickAdd() {
    var uniKey_Locking = [];
    var uniKey_bus_id_list = [];
    var set_bus_id_list = "";
    var DataSet = [];
    let cate = categoryData[selCategory]

    for (let i = 0; i < lockedData.length; i++) {
      uniKey_Locking.push(lockedData[i].bus_locking_id);
    }
    let unique = [...new Set(uniKey_Locking)];
    for (let i = 0; i < unique.length; i++) {
      const result = lockedData.filter(data => data.bus_locking_id === unique[i]);
      DataSet.push(result[0]);
      for (let r = 0; r < result.length; r++) {
        set_bus_id_list += result[r].bus_id + ",";
      }
      uniKey_bus_id_list.push(set_bus_id_list.substring(0, (set_bus_id_list.length - 1)));
      set_bus_id_list = "";
    }
    for (let i = 0; i < DataSet.length; i++) {
      Api.post("v2/bus_open_job", {
        "i_bus_id_list": uniKey_bus_id_list[i]
        , "i_interface_type": cate.interface_type //
        , "i_interface_sub_type": cate.interface_sub_type//
        , "i_bus_locking_id": unique[i]
        , "i_inform_detail": selInform //
        , "i_inform_remark": selRemark //
        , "i_plan_start_date": selPlanStart //
        , "i_plan_end_date": selPlanEnd //
        , "i_ma_period_id": selPeriod //
        , "r_create_by": Cookies.get("userId") //
        , "i_single_job_flag": i_single_job_flag ? 1 : 0

      }).then((res) => {
        Cookies.set("activeTab", 1, { expires: 1 })
        setmodalstatus(true);
      });
      if (i === DataSet.length) {
        alert('open job success')
        handleVisible(false)
        window.location.reload(false);
      }

    }

  }
  lockedData.forEach((item) => {
    item.internalAds = checkStatusInternal(
      item.fw,
      item.qw,
      item.led,
      item.special
    );
    item.externalAds = checkStatusExternal(
      item.ib,
      item.hg,
      item.lcd
    );
  });
  // const [isModalVisible, setIsModalVisible] = useState(false);

  const columns = [
    {
      title: "Plate No.",
      dataIndex: "license_plate",
      key: "license_plate",
      render: (item) => (
        item === null || item === "" ? "-" : item
      ),
      sorter: (a, b) => {
        if( (a.license_plate !== undefined && b.license_plate !== undefined) &&  (a.license_plate !== null && b.license_plate !== null) ){ 
                return   a.license_plate.localeCompare(b.license_plate)
        }
     }
      
    },
    {
      title: "Line No.",
      dataIndex: "bus_line_name",
      key: "bus_line_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.bus_line_name !== undefined && b.bus_line_name !== undefined) &&  (a.bus_line_name !== null && b.bus_line_name !== null) ){ 
                return   a.bus_line_name.localeCompare(b.bus_line_name)
        }
     }
    },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "area_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.area_name !== undefined && b.area_name !== undefined) &&  (a.area_name !== null && b.area_name !== null) ){ 
                return   a.area_name.localeCompare(b.area_name)
        }
     }
    },

    {
      title: "Garage Name",
      dataIndex: "garage_name",
      key: "garage_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.garage_name !== undefined && b.garage_name !== undefined) &&  (a.garage_name !== null && b.garage_name !== null) ){ 
                return   a.garage_name.localeCompare(b.garage_name)
        }
     }
    },


    {
      title: "Bus No.",
      dataIndex: "bus_no",
      key: "bus_no",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.bus_no !== undefined && b.bus_no !== undefined) &&  (a.bus_no !== null && b.bus_no !== null) ){ 
                return   a.bus_no.localeCompare(b.bus_no)
        }
     }
    },
    {
      title: "Model",
      dataIndex: "model_name",
      key: "model_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.model_name !== undefined && b.model_name !== undefined) &&  (a.model_name !== null && b.model_name !== null) ){ 
                return   a.model_name.localeCompare(b.model_name)
        }
     }
    },
    {
      title: "External Ads",
      dataIndex: "external_ads",
      key: "external_ads",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.external_ads !== undefined && b.external_ads !== undefined) &&  (a.external_ads !== null && b.external_ads !== null) ){ 
                return   a.external_ads.localeCompare(b.external_ads)
        }
     }
    },
    {
      title: "Prev External Ad Name",
      dataIndex: "prev_external_ad_name",
      key: "prev_external_ad_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.prev_external_ad_name !== undefined && b.prev_external_ad_name !== undefined) &&  (a.prev_external_ad_name !== null && b.prev_external_ad_name !== null) ){ 
                return   a.prev_external_ad_name.localeCompare(b.prev_external_ad_name)
        }
     }
    },
    {
      title: "Internal Ads",
      dataIndex: "internal_ads",
      key: "internal_ads",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.internal_ads !== undefined && b.internal_ads !== undefined) &&  (a.internal_ads !== null && b.internal_ads !== null) ){ 
                return   a.internal_ads.localeCompare(b.internal_ads)
        }
     }
    },
    {
      title: "Prev Internal Ad Name",
      dataIndex: "prev_internal_ad_name",
      key: "prev_internal_ad_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.prev_internal_ad_name !== undefined && b.prev_internal_ad_name !== undefined) &&  (a.prev_internal_ad_name !== null && b.prev_internal_ad_name !== null) ){ 
                return   a.prev_internal_ad_name.localeCompare(b.prev_internal_ad_name)
        }
     }
    },

    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.remark !== undefined && b.remark !== undefined) &&  (a.remark !== null && b.remark !== null) ){ 
                return   a.remark.localeCompare(b.remark)
        }
     }
    },


    {
      title: "Internal Advertise Name",
      dataIndex: "internal_advertise_name",
      key: "internal_advertise_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.internal_advertise_name !== undefined && b.internal_advertise_name !== undefined) &&  (a.internal_advertise_name !== null && b.internal_advertise_name !== null) ){ 
                return   a.internal_advertise_name.localeCompare(b.internal_advertise_name)
        }
     }
    },
    {
      title: "External Advertise Name",
      dataIndex: "external_advertise_name",
      key: "external_advertise_name",
      render: (item) => (
        item === null || item === "" ? "-" : item
      )
      ,
      sorter: (a, b) => {
        if( (a.external_advertise_name !== undefined && b.external_advertise_name !== undefined) &&  (a.external_advertise_name !== null && b.external_advertise_name !== null) ){ 
                return   a.external_advertise_name.localeCompare(b.external_advertise_name)
        }
     }
    },
  ];
  return (
    <>
      {modalstatus ? (
        <ModalSuccess
          status="Successfully"
          path_location="/MaxiOperation/bus_status_checking"
        />
      ) : null}

      <Modal
        title="Locking Document"
        visible={true}
        width={900}
        onCancel={() => handleVisible(false)}
        footer={[
          <div className="text-center">
            {[
              <Button key="Cancel" onClick={() => handleVisible(false)}>
                Cancel
              </Button>,
              <Button
                key="Add"
                className="btn-warning"
                style={{ background: "#E8CD00" }}
                onClick={() => clickAdd()}
              >
                Add Job
              </Button>,
            ]}
          </div>,
        ]}
      >
        {/* for many input */}
        <div
          style={{ padding: "0px 80px" }}
        >
          <div className="row">
            <div className="col-12">
              {/* Categories */}
              <span className="font-thai-b fs-22 c-blue">{"Categories"}</span>
              <br />
              <Select
                // defaultValue="Printing"
                style={{ width: "100%" }}
                onChange={(val) => {
                  console.log('Categories', val);
                  setSelCategory(val)
                }}
              >
                {categoryData.map((data, index) => (
                  <Option
                    key={`category_${index}`}
                    value={index}
                  // value={data.interface_type}
                  >
                    {data.interface_type} - {data.interface_sub_type}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="row mt-2">
            {/* <div className="col-6">
              <Checkbox onChange={(e) => seti_single_job_flag(e.target.checked)}>
                <span className="font-thai-b fs-22 c-blue">{"เปิด job เดียว"}</span>
              </Checkbox>
            </div> */}
            {/* onChange={onChange} */}
          </div>
          <div className="row">
            <div className="col-5">
              {/* Vendor */}
              <span className="font-thai-b fs-22 c-blue">{"MA Period"}</span>
              <br />
              {/* <Input placeholder="Please input" /> */}
              <Select
                placeholder="Please select"
                // value="Bus Group"
                style={{ width: "100%" }}
                onChange={(val) => {
                  console.log('ma period', val);
                  setSelPeriod(val)
                }}
              // mode="multiple"
              // allowClear
              >
                {periodData.map((data, index) => (
                  <Option
                    key={`period_${index}`}
                    value={data.ma_period_id}
                  >
                    {data.ma_period_name}
                  </Option>
                ))}
              </Select>
              {/* 

              {/* <Input placeholder="Please Input"></Input> */}
            </div>
            {/* Date */}
            <div className="col-7">
              <span className="font-thai-b fs-22 c-blue">{"Plan Start - End"}</span>
              <br />
              {/* <DatePicker placeholder="Start Date" style={{ width: "370px" }} /> */}
              <RangePicker
                onChange={(val) => {
                  console.log("handle range picker", val);
                  let start = moment(val[0]).format('YYYY-MM-DD');
                  let end = moment(val[1]).format('YYYY-MM-DD');
                  console.log('start', start);
                  console.log('end', end);
                  setSelPlanStart(start)
                  setSelPlanEnd(end)
                }}
                // style={{ width: "370px", paddingLeft: "10px" }}
                allowClear
                style={{
                  marginLeft: "10px",
                  color: "#000F9F",
                  marginRight: "20px",
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {/* Inform Details */}
              <span className="font-thai-b fs-22 c-blue">{"Inform Details"}</span>
              <br />
              <TextArea rows={4} value={selInform}
                onChange={handleChangeInform}
              />
              {/* <Select
                defaultValue="Printing"
                style={{ width: "600px" }}
              ></Select> */}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {/* Inform Details */}
              <span className="font-thai-b fs-22 c-blue">{"Remark"}</span>
              <br />
              <TextArea rows={4}
                value={selRemark}
                onChange={handleChangeRemark}
              // onChange={(event) => { 
              //   console.log(event.target.value);
              //   // console.log('detail',val); 
              //   // setSelInform(val)
              //  }}
              />


              {/* <Select
                defaultValue="Printing"
                style={{ width: "600px" }}
              ></Select> */}
            </div>
          </div>

        </div>
        <hr />
        {/* for table */}
        <Table rowKey={"bus_id"} columns={columns} dataSource={lockedData} pagination={false} scroll={{ x: true }} />
      </Modal>
    </>
  );
};

export default LockingDocumentModal;
